"use client"

import {
    Combobox,
    useFilter,
    useListCollection,
} from "@chakra-ui/react"
import Field from "../field"

export default function BankSelect({ items = [], onValueChange, value, ...props }) {
    const { contains } = useFilter({ sensitivity: "base" })

    // JONATAN: Mapeamos garantindo que temos o ID real e o Código COMPE
    const formattedItems = items.map(bank => ({
        label: `${bank.bc_compe} - ${bank.name}`,
        value: String(bank.id),           // ID da tabela banks
        bc_compe: String(bank.bc_compe),  // Código COMPE
    }))

    const { collection, filter } = useListCollection({
        initialItems: formattedItems,
        filter: contains,
    })

    // JONATAN: Sincroniza o visual do Select usando o bank_id que vem do Form
    const getInternalValue = () => {
        if (!value) return [];
        return [String(value)];
    }

    return (
        <Field {...props}>
            <Combobox.Root
                collection={collection}
                onInputValueChange={(e) => filter(e.inputValue)}
                // JONATAN: Dispara os dois valores para o componente pai
                onValueChange={(e) => {
                    const selectedId = e.value[0];
                    const item = formattedItems.find(i => i.value === selectedId);
                    onValueChange?.(item?.value || '', item?.bc_compe || '');
                }}
                value={getInternalValue()}
                disabled={props.disabled}
                width="100%"
                portalled={false}
            >
                <Combobox.Control>
                    <Combobox.Input placeholder={props.placeholder || "Pesquise o banco..."} />
                    <Combobox.IndicatorGroup>
                        <Combobox.ClearTrigger />
                        <Combobox.Trigger />
                    </Combobox.IndicatorGroup>
                </Combobox.Control>

                <Combobox.Positioner zIndex="popover">
                    <Combobox.Content
                        bg="bg.panel"
                        shadow="md"
                        borderRadius="md"
                        border="1px solid"
                        borderColor="border.muted"
                        maxH="200px"
                        overflow="auto"
                    >
                        <Combobox.Empty>Banco não encontrado</Combobox.Empty>
                        {collection.items.map((item) => (
                            <Combobox.Item
                                item={item}
                                key={item.value}
                                _hover={{ bg: "bg.muted", cursor: "pointer" }}
                                p={2}
                            >
                                {item.label}
                                <Combobox.ItemIndicator />
                            </Combobox.Item>
                        ))}
                    </Combobox.Content>
                </Combobox.Positioner>
            </Combobox.Root>
        </Field>
    )
}